import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Dasboard from './apps/dashboard/App';
import Auth from './apps/auth/App';
import { paths as dashboardPaths } from './apps/dashboard/routes';
import { pathTemplates as authPaths } from './apps/auth/routes';
import { useCurrentLocale } from './context/I18n';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { SkeletonTheme } from 'react-loading-skeleton';
import { Theme } from './theme';
import { withChildren } from './utils/react';

const SkeletonThemeWithChildren = withChildren(SkeletonTheme);
const RouterWithChildren = withChildren(Router);

const App: React.FC<React.PropsWithChildren<unknown>> = () => {
  const locale = useCurrentLocale();
  moment.locale(locale);

  return (
    <>
      <Helmet>
        <html lang={locale} />
      </Helmet>
      <SkeletonThemeWithChildren
        color={Theme.color.paper4}
        highlightColor={Theme.color.paper5}>
        {/*
          StrictMode is deliberately NOT enabled. Its dev-only
          mount -> unmount -> remount cycle breaks react-router v5: Router
          subscribes to history in its constructor and detaches in
          componentWillUnmount, so client-side navigation dies. See
          App.router-strictmode.test.tsx.

          This is dev-only, but it makes the app untestable in development.
          Re-enable StrictMode once react-router is upgraded to a
          StrictMode-safe version.
        */}
        <RouterWithChildren>
          <AuthProvider>
            <Switch>
              <Route path={authPaths}>
                <Auth />
              </Route>
              <Route path={dashboardPaths}>
                <Dasboard />
              </Route>
            </Switch>
          </AuthProvider>
        </RouterWithChildren>
      </SkeletonThemeWithChildren>
    </>
  );
};

export default App;
